"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
/* DESTRUCTURING */
const { apply } = Reflect;
/* APPLICATORS */
const add = (method, thisArg, thisArgTarget, args) => {
    const prev = thisArgTarget.has(args[0]);
    if (prev)
        return [thisArg, false];
    const result = apply(method, thisArg, args);
    return [result, true];
};
const del = (method, thisArg, thisArgTarget, args) => {
    const prev = thisArgTarget.has(args[0]);
    if (!prev)
        return [false, false];
    const result = apply(method, thisArg, args);
    return [result, true];
};
const clear = (method, thisArg, thisArgTarget, args) => {
    const { size } = thisArgTarget;
    if (!size)
        return [undefined, false];
    const result = apply(method, thisArg, args);
    return [result, true];
};
/* SET */
const Set = { add, delete: del, clear };
/* EXPORT */
exports.default = Set;
